import { useMemo } from 'react';
import { useRouter } from 'next/router';

import FilterMenu from '~/src/components/FilterMenu';
import sendSelectFilter from '~/src/features/bundles/analytics/sendSelectFilter';
import { PATH_BUNDLES_LINK_CITY, PATH_BUNDLES_LINK_VILLAGE, TAB_FLAT, TAB_VILLAGE } from '~/src/features/index/Tariffs/constants';

import * as ST from './styled';

interface IProps {
    isVillage: boolean,
    isLoading: boolean,
}

const Filter = ({ isVillage, isLoading }: IProps) => {
    const router = useRouter();
    const filterMenuItems = useMemo(() => [
        {
            text: TAB_FLAT,
            action: () => {
                router.push(PATH_BUNDLES_LINK_CITY);
            },
        },
        {
            text: TAB_VILLAGE,
            action: () => {
                sendSelectFilter();
                router.push(PATH_BUNDLES_LINK_VILLAGE);
            },
        },
    ], [router]);

    return (
        <ST.Wrapper>
            <FilterMenu
                items={filterMenuItems}
                activeItem={!isVillage ? 0 : 1}
                disabled={isLoading}
            />
        </ST.Wrapper>
    );
};

export default Filter;
